import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionStorageService } from '../../shared-services/services/session-storage.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    private trackingId: string | null = null;
    constructor(
        private router: ActivatedRoute,
        private sessionStorageService: SessionStorageService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const authToken = this.sessionStorageService.getAuthToken();

        let headers = request.headers;

        if (authToken && authToken.accessToken) {
            headers = headers.set('Authorization', `Bearer ${authToken.accessToken}`);
        }

        if (this.router.snapshot.queryParams.tid) {
            this.trackingId = this.router.snapshot.queryParams.tid;
        } else {
            if (this.trackingId) {
                headers = headers.delete('FL-STEPBYSTEPGUIDE-TRACKINGID');
                this.trackingId = null;
            }
        }

        if (this.trackingId) {
            headers = headers.set('FL-STEPBYSTEPGUIDE-TRACKINGID', this.trackingId);
        }

        const finlockerTrackingId = this.sessionStorageService.getItem('fl-tracking-id');
        const finlockerTrackedBy = this.sessionStorageService.getItem('fl-tracked-by');

        if (finlockerTrackingId) {
            headers = headers.set('FL-TRACKINGID', finlockerTrackingId);
        }

        if (finlockerTrackedBy) {
            headers = headers.set('FL-TRACKEDBY', finlockerTrackedBy);
        }

        headers = headers.set('FL-APP', 'pfm-web');
        headers = headers.set('FL-LOCALE', 'en-US');

        const clonedRequest = request.clone({ headers });

        return next.handle(clonedRequest);
    }
}
